import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTABand = ({ onRequestQuote }) => {
  return (
    <section className="cta-band">
      <div className="container">
        <h2>Ready to discuss your requirements?</h2>
        <p>
          Send your drawing or specification and get a quote within 24-48 hours.
        </p>
        <button className="btn-primary" onClick={onRequestQuote}>
          Request a Quote
          <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
};

export default CTABand;
